const slugifyPart = (value) => {
  if (!value) return "";
  return String(value)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
};

export const parseEventIdFromParam = (rawParam) => {
  if (!rawParam) return null;
  const firstChunk = String(rawParam).split("-")[0];
  const parsed = Number.parseInt(firstChunk, 10);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return parsed;
};

export const buildEventPath = (eventId, eventName = "") => {
  const id = Number.parseInt(eventId, 10);
  if (!Number.isFinite(id) || id <= 0) return "/events/search";
  const slug = slugifyPart(eventName);
  return slug ? `/events/${id}-${slug}` : `/events/${id}`;
};

export const isPlainLeftClick = (event) =>
  event.button === 0 &&
  !event.defaultPrevented &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey;
